<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <h5 class="modal-title">Send WhatsApp Template</h5>
    <app-page-help articleId="-" videoId="-"></app-page-help>
  </div>
  <button (click)="onClose()" type="button" class="close" aria-label="Close">
    <span><i class="far fa-times"></i></span>
  </button>
</div>
<div class="modal-body">
  <div class="alert alert-secondary-warning2 align-items-start p-2">
    <i class="fal fa-exclamation-triangle alert-icon"></i>
    <div class="alert-content text-sm">
      <div>
        <span class="fw-semibold">Note:</span>
        <ng-container i18n>
          WhatsApp has special templates and is non-editable. You cannot use the same template as Email, Gmail, or other
          platforms.
        </ng-container>
      </div>
      <div i18n>If you’ve selected and edited a template for another platform, it will stay saved in the editor.</div>
      <div i18n>Once you send this WhatsApp message, you can go back and continue sending other messages.</div>
    </div>
  </div>

  <app-loading-section *ngIf="isLoading"></app-loading-section>
  <form [formGroup]="form" *ngIf="!isLoading">
    <mat-radio-group
      formControlName="whatsappTemplateId"
      class="d-flex flex-column justify-content-start gap-2"
      (change)="onTemplateChange($event)"
    >
      <ng-container *ngFor="let template of whatsappTemplates">
        <mat-radio-button [value]="template.sid" #btn>
          {{ template.name | titleCase }}
        </mat-radio-button>
        <div *ngIf="btn.checked" class="rounded p-2 bg-default text-sm ml-4">
          <textarea
            [value]="compiledTemplate"
            readonly
            cdkTextareaAutosize
            class="border-0 p-0 w-100 bg-none"
            style="outline: none"
          >
          </textarea>
          <div class="text-light mt-2">
            <i class="cs-icon cs-icon-pencil-slash"></i>
            <ng-container i18n>This is a predefined message and cannot be edited.</ng-container>
          </div>
        </div>
      </ng-container>
    </mat-radio-group>
  </form>
</div>
<div class="modal-footer">
  <button (click)="onClose()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="onSave(form)" [disabled]="form.invalid" type="button" class="btn btn-secondary-info">
    <i class="far fa-paper-plane"></i>
    <ng-container i18n>Send</ng-container>
  </button>
</div>
